import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit {
  cards = [
    {
      title: 'Lead & Activity Management',
      description: ['Capture and track new leads from multiple source.', 'Lead status tracking (new, contacted, qualified, converted, lost)',
        'Lead follow-up reminders and task scheduling', 'Schedule property showings and open houses'
      ],
      image: 'assets/images/LeadPropertyList.jpg',
    },
    {
      title: 'Property Management',
      description: ['Manage property listings, including details, images, and availability.',
        'Property performance analytics (views, inquiries, offers)', 'Property status (available, under contract, sold, rented)'],
      image: 'assets/images/HomePage.jpg',
    },
    {
      title: 'User/Teams Management',
      description: ['Create new user/Team', 'Assign leads to agents or teams', 'Role-based access control (admin, agent, client)'],
      image: 'assets/images/UserTeam.jpg',
    },
    {
      title: 'Calling Module',
      description: ['Imports multiple clients number', 'Assign numbers to employees', 'Instantly call leads or clients from within the app', 'Automatically log call details (date, time, duration, contact)',
        'Create calling leads and clients'
      ],
      image: 'assets/images/Calling.jpg',
    },
    {
      title: 'Project Management',
      description: ['Create and manage new construction projects','Assign project managers and teams',
        'Upload and manage blueprints, permits, contracts, and other documents'
      ],
      image: 'assets/images/ProjectDetail.jpg',
    },
    // ...add 8 more cards
  ];

  constructor() { }

  ngOnInit(): void { }
  openPlaystoreAgent() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.crf.agent_builder'
    );
  }
  openPlaystoreOwner() {
    window.open(
      'https://play.google.com/store/apps/details?id=com.crf.clorent_factory'
    );
  }

  openAppstoreOwner() {
    window.alert('Comming Soon');
  }

  openAppstoreAgent() {
    window.open(
      'https://apps.apple.com/in/app/clorent-factory-agent-builder/id1670704178'
    );
  }
}
